import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Terms from "../pages/terms/page";
import Foundation from "../pages/foundation/page";
import Business from "../pages/business/page";
import Store from "../pages/store/page";
import PortalLogin from "../pages/portal/login/page";
import PortalDashboard from "../pages/portal/dashboard/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/terms", element: <Terms /> },
  { path: "/foundation", element: <Foundation /> },
  { path: "/business", element: <Business /> },
  { path: "/store", element: <Store /> },
  { path: "/portal/login", element: <PortalLogin /> },
  { path: "/portal", element: <PortalDashboard /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
